import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../../service/service.js';
import {BillingService} from '../../../service/billing/billingService.js';
import {ElementUtil} from '../../../utils/elementUtil.js';
import {TimeUtil} from '../../../utils/timeUtil.js';
import {StringUtil} from '../../../utils/stringUtil.js';
import {BaseComponent} from '../../basecomponent.js';


/* global customElements */
class GeneralInfo extends BaseComponent {
	
	static get properties() {
		return {
			admin: {type: Boolean}
		};
	}
	
	constructor() {
		super();		
		
		var generalInfo = this;
		setTimeout(function(){
			generalInfo.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var generalInfo = this;
		
		generalInfo.detailTable = ElementUtil.create({
			tag: 'dl-detail-table',
			itemid: 'detailtable',
			style: 'width: 98%; margin: 10px',
			slot: 'primary'
		});	
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				generalInfo.detailTable
			]
		});		
		generalInfo.append(flexLayout);	
	
		var readyEvent = new CustomEvent('ready', { detail: '' });
		generalInfo.dispatchEvent(readyEvent);		
	}
	
	updateInfo(accountData) {
		var generalInfo = this;
		generalInfo.detail = accountData;		
		
		var detailData = [];
		var addDetail = function(dataFields) {
			dataFields.forEach(function(dataField) {
				if (dataField.value) {
					detailData.push(dataField);					
				}
			});
		};
		
		var data = [
			{
				key: 'Account',
				value: '-',
				section: true
			},			
			{
				key: 'Company Id',
				value: generalInfo.detail.companyId
			},
			{
				key: 'Company Name',
				value: generalInfo.detail.companyName
			},
			{
				key: 'Company Reference No',
				value: generalInfo.detail.companyReferenceCode
			},
			{
				key: 'EFS Carrier Id',
				value: generalInfo.detail.carrierId
			},
			{
				key: 'Parent Company Name',
				value: generalInfo.detail.parentCompanyName
			},
			{
				key: 'Status',
				value: generalInfo.detail.accountStatusDescription ? generalInfo.detail.accountStatusDescription : 'N/A'
			},
			{
				key: 'Balance',
				value: StringUtil.currencyFormat(generalInfo.detail.currentBalance)
			},
			{
				key: 'Last Cycle Date',
				value: TimeUtil.formatBillingCalendarDate(generalInfo.detail.lastCycleDate) + ' (' + (generalInfo.detail.account.billingBehindFlag ? 'Behind' : 'Ahead') + ')'
			},
			{
				key: 'Next Cycle Period',
				value: TimeUtil.formatBillingCalendarDate(generalInfo.detail.nextCycleStartDate) + ' - ' + TimeUtil.formatBillingCalendarDate(generalInfo.detail.nextCycleEndDate)
			},			
			{
				key: 'Payment Type - Options',
				value: generalInfo.detail.account.paymentTypeDescription + ' - ' + generalInfo.detail.account.paymentOptionDescription 
			},
			{
				key: 'Billing Start Date',
				value: TimeUtil.formatBillingCalendarDate(generalInfo.detail.account.billingStartDate)
			},
			{
				key: 'Do Not Bill',
				value: generalInfo.detail.account.doNotBillFlag ? 'True' : 'False'
			},
			{
				key: 'Open Date',
				value: TimeUtil.formatDateStandard(generalInfo.detail.account.accountOpenDts)
			},
			{
				key: 'Close Date',
				value: TimeUtil.formatDateStandard(generalInfo.detail.account.accountCloseDts)
			},
			{
				key: 'Create Date',
				value: TimeUtil.formatDateStandard(generalInfo.detail.account.createDts)
			},
			{
				key: 'Inside Sales Rep',
				value: generalInfo.detail.account.insideRepFull ? generalInfo.detail.account.insideRepFull.repFirstName + ', ' + generalInfo.detail.account.insideRepFull.repLastName + ' (' + generalInfo.detail.account.insideRepFull.repEmail + ')': null
			},
			{
				key: 'Outside Sales Rep',
				value: generalInfo.detail.account.outsideRepFull ? generalInfo.detail.account.outsideRepFull.repFirstName + ', ' + generalInfo.detail.account.outsideRepFull.repLastName + ' (' + generalInfo.detail.account.outsideRepFull.repEmail + ')' : null
			},			
			{
				key: 'Contact Information',
				value: '-',
				section: true
			},
			{
				key: 'Billing Contact Name',
				value: [generalInfo.detail.account.billingFirstName, generalInfo.detail.account.billingLastName]
					.filter(Boolean).join(', ') || null
			},
			{
				key: 'Billing Contact Phone',
				value: generalInfo.detail.account.billingPhone
			},
			{
				key: 'Billing Contact Email',
				value: generalInfo.detail.account.billingEmail
			},
			{
				key: 'Billing Address',
				value: generalInfo.detail.billingAddress.addressLine1 + 
						(generalInfo.detail.billingAddress.addressLine2 ? '<br>' + generalInfo.detail.billingAddress.addressLine2 : '') +
						(generalInfo.detail.billingAddress.addressLine3 ? '<br>' + generalInfo.detail.billingAddress.addressLine3 : '')
			},
			{
				key: 'Billing City',
				value: generalInfo.detail.billingAddress.cityName
			},
			{
				key: 'Billing State/Province',
				value: generalInfo.detail.billingAddress.state + ', ' + generalInfo.detail.billingAddress.country
			},
			{
				key: 'Billing Postal Code',
				value: generalInfo.detail.billingAddress.postalCode
			}
		];	
		addDetail(data);	
		
		generalInfo.detailTable.updateDetails(detailData);			
	}
	
};
customElements.define('dl-account-general-info', GeneralInfo);
